import {useState} from "react";
import authApi from "./api/authApi";
import {useNavigate} from "react-router-dom";
import {getConfig} from "../../configs/appConfig";
import {Storage} from "../../apiHelper/Storage";

/**
 * Custom hook with authorization logic
 *
 * @returns object
 */

const storage = Storage();

const useLogin = () => {
    const navigate = useNavigate();

    const [user_data, setUser_Data] = useState(null);
    const [isLogin, setIsLogin] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [isLoadingInit, setLoadingInit] = useState(true);
    const [user_name, setUser_Name] = useState("");

    const [errorMessage, setErrorMessage] = useState("");
    const [user_password, setUser_Password] = useState("");


    const handleChangeName = e => setUser_Name(e.target.value.trim());

    const handleChangePassword = e => setUser_Password(e.target.value.trim());


    const fetchToken = async () => {
        const params = {
            grant_type: "password",
            username: user_name,
            password: user_password,
            client_id: getConfig("auth_client_id"),
            client_secret: getConfig("auth_client_secret"),
        };

        try {
            const response = await authApi.getToken(params);

            if (response.errorMsg) {
                setErrorMessage(
                    typeof response.errorMsg === 'string' ?
                        response.errorMsg === 'Wrong login or password' ? 'Не вірний логін або пароль' : response.errorMsg : 'Щось пішло не так...'
                )
                return;
            }

            const {expires_in, access_token, refresh_token} = response;

            if (access_token) {

                await handleSaveTokenInCookie(access_token, expires_in, refresh_token);
                setErrorMessage(null)
                return access_token
            }
        } catch (error) {
            console.log(error);
            setErrorMessage(typeof error.errorMsg === 'string' ? error.errorMsg : 'Щось пішло не так...')
            return null
        }
    };

    /**
     * Method set token data in a cookie
     *
     * @params token         object
     * @params token_max_age object
     */
    async function handleSaveTokenInCookie(token, token_max_age, refreshToken) {
        storage.set("token", token, {
            expires: token_max_age,
            path: "/",
        })
        storage.set("refresh_token", refreshToken, {
            path: "/",
        });
    }


    const fetchUserInfo = async (accessToken,withoutMessage) => {
        let params = {access_token: accessToken};

        try {
            const response = await authApi.getUserInfo(params);

            if (response.errorMsg ) {
                if(!withoutMessage){
                    setErrorMessage(response.errorMsg);
                }

                setIsLogin(false)
                setLoading(false);
                return
            }

            setUser_Data(response)
            try {
                await fetchSaveUserData(response);
            } catch (error) {
                console.log(error)
            }
            setLoading(false);
            setIsLogin(true)

        } catch (error) {
            setIsLogin(false)
            setLoading(false);
            console.log(error);
        }
    };

    /**
     * Method save admin data
     *
     * @params   obj
     * @returns  func
     */
    const fetchSaveUserData = async userData => {
        let params = {
            open_user_id: userData.id,
            picture: String(userData.picture),
            family_name: userData.family_name,
            given_name: userData.given_name,
            middle_name: String(userData.middle_name)
        };

        const response = await authApi.saveUserInfo(params);

        if (response.errors.length > 0) {
            setErrorMessage(response.errors[0]);
            return false
        }
        return true
    }


    const Login = async () => {
        setErrorMessage(null);

        if (user_name.length && user_password.length) {
            const token = await fetchToken();
            if (token) {
                await fetchUserInfo(token);
            }

        }

    };

    /**
     * Method log out the user
     */
    const Logout = () => {
        setIsLogin(false);
        setErrorMessage("");
        storage.remove("token");
        storage.remove("refresh_token");
        setUser_Name("");
        setUser_Password("");
        navigate("/");
        window.location.reload();
    };

    /**
     * All auth data
     */
    const auth_data = {
        Login,
        Logout,
        isLogin,
        user_data,
        user_name,
        isLoading,
        setLoading,
        setIsLogin,
        errorMessage,
        user_password,
        fetchUserInfo,
        handleChangeName,
        handleChangePassword,
        isLoadingInit,
        setLoadingInit
    };

    return auth_data;
};

export default useLogin;
